export enum PSNotificationTypes {
  INFO,
  ERROR,
  LOAD_ERROR,
  PLAYBACK_ERROR,
  OUT_OF_CONTENT, // We tried to get more content from server, but couldn't, and now we be silent
  ALMOST_OUT_OF_CONTENT, // Out of content, but we are still playing, so don't mess that up!
  MIX_PLAYED_OUT, // We have played the last media item in the mix, and are now silent
  OUT_OF_SKIPS,
  MIX_LOADING,
  MIX_LOADED,
  MIX_STARTED,
  FIRST_MIX_STARTED,
  SCHEDULING_ITEM_CHANGED,
}

export interface PSNotification {
  type: PSNotificationTypes;
  message: string;
}
